module.exports = __webpack_public_path__ + "assets/img/39df8f03990609f120a132dc4568b7bc.svg";